/** Devise de l'école : symbole affiché après les montants et nom en lettres (reçus). Aucune conversion. */
export interface Currency {
  symbol: string;
  /** Nom au singulier : « franc guinéen ». */
  name: string;
  /** Nom au pluriel : « francs guinéens ». */
  plural: string;
}

/** Devises proposées dans Paramètres (« Autre » permet d'en saisir une). */
export const CURRENCIES: ReadonlyArray<Currency & { label: string }> = [
  { label: "Franc guinéen (FG)", symbol: "FG", name: "franc guinéen", plural: "francs guinéens" },
  { label: "Franc guinéen (GNF)", symbol: "GNF", name: "franc guinéen", plural: "francs guinéens" },
  { label: "Franc CFA (FCFA)", symbol: "FCFA", name: "franc CFA", plural: "francs CFA" },
  { label: "Euro (€)", symbol: "€", name: "euro", plural: "euros" },
  { label: "Dollar américain ($)", symbol: "$", name: "dollar", plural: "dollars" },
  { label: "Franc congolais (FC)", symbol: "FC", name: "franc congolais", plural: "francs congolais" },
  { label: "Dirham marocain (DH)", symbol: "DH", name: "dirham", plural: "dirhams" },
  { label: "Leone (SLE)", symbol: "SLE", name: "leone", plural: "leones" },
];

export const DEFAULT_CURRENCY: Currency = { symbol: "FG", name: "franc guinéen", plural: "francs guinéens" };

let current: Currency = DEFAULT_CURRENCY;

/** Appelé au chargement de la fiche de l'école : tous les montants affichés suivent ensuite cette devise. */
export function setCurrency(currency: Partial<Currency>): void {
  current = {
    symbol: currency.symbol?.trim() || DEFAULT_CURRENCY.symbol,
    name: currency.name?.trim() || DEFAULT_CURRENCY.name,
    plural: currency.plural?.trim() || DEFAULT_CURRENCY.plural,
  };
}

export const getCurrency = (): Currency => current;

/** Symbole de la devise, pour les libellés (« Montant (FG) »). */
export const currencySymbol = (): string => current.symbol;

/** « Franc guinéen (FG) » : mention des documents imprimés. */
export const currencyLabel = (): string =>
  `${current.name.charAt(0).toUpperCase()}${current.name.slice(1)} (${current.symbol})`;
